import React from "react";
import classNames from "classnames/bind";
import s from "./sideDetailsTemplate.module.scss";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import CustomeExpansionPanel from "../../CustomExpansionPanel/CustomeExpansionPanel";
import ListComponent from "../../ListComponent/ListComponent";
import { Tooltip } from "@material-ui/core";
import AboutMe from "../../AboutMe/AboutMe";
import Education from "../../Education/Education";
import { getMakeStyleClasses } from "../../common/getMakeStyleClasses";
import EditIcon from "@material-ui/icons/Edit";
import { SECTION } from "../../../constants/constants";
import { motion } from "framer-motion";
import ExpertiseComponent from "../../ExpertiseComponent/ExpertiseComponent";
import { hexToRgbA } from "../../common/utils";

const SideDetailsTemplate = (props) => {
  const { editMode, constraintsRef, handleClick } = props;
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  return (
    <div
      className={cx(s.resumeContainer, {
        [s.twoColumnTemplate]: props.viewType.templateTwoColumnType,
      })}
      ref={constraintsRef}
    >
      <Paper
        className={cx(
          classes.section,
          classes.leftSection,
          s.header,
          s.resumeSectionContainer
        )}
      >
        <AboutMe
          data={props.initialData.aboutMe}
          templateStyle="colour-template"
        />
        {editMode && (
          <div className={s.aboutMeEditBtnContainer}>
            <IconButton
              aria-label="delete"
              className={classes.iconDetailOverride}
              onClick={(evt) => handleClick(evt, SECTION.ABOUT_ME)}
            >
              <Tooltip title="Edit About Me" aria-label="Edit About Me">
                <EditIcon className={classes.iconDetailOverride} />
              </Tooltip>
            </IconButton>
          </div>
        )}
      </Paper>
      <motion.div
        drag={editMode}
        dragConstraints={constraintsRef}
        className={cx(
          // classes.section,
          s.workExperience,
          s.resumeSectionContainer
        )}
      >
        <h2
          className={cx(
            classes.primaryThemeColor,
            s.sectionHeading,
            classes.sectionUnderline,
            {
              [s.editMode]: editMode,
            }
          )}
        >
          <Tooltip
            title={
              editMode
                ? SECTION.EDIT_SECTION_NAME.EDIT_MODE
                : SECTION.EDIT_SECTION_NAME.VIEW_MODE
            }
          >
            <span
              suppressContentEditableWarning={true}
              className={classes.editableDiv}
              contentEditable={editMode}
            >
              Work Experience
            </span>
          </Tooltip>

          {editMode && (
            <span>
              <IconButton
                className={classes.iconDetailOverride}
                aria-label="delete"
                onClick={(evt) => handleClick(evt, SECTION.WORK_EX)}
              >
                <Tooltip
                  title="Edit Work Experience"
                  aria-label="Edit Work Experience"
                >
                  <EditIcon className={classes.iconDetailOverride} />
                </Tooltip>
              </IconButton>
            </span>
          )}
        </h2>
        <CustomeExpansionPanel
          workEx={props.initialData.workEx}
          // templateStyle="vertical"
        />
      </motion.div>
      <motion.div
        drag={editMode}
        dragConstraints={constraintsRef}
        className={cx(s.skills, s.resumeSectionContainer)}
      >
        <Paper className={cx(classes.section, classes.leftSection)}>
          <h2
            className={cx(
              classes.primaryThemeColor,
              classes.sectionUnderline,
              s.sectionHeading,
              {
                [s.editMode]: editMode,
              }
            )}
          >
            <Tooltip
              title={
                editMode
                  ? SECTION.EDIT_SECTION_NAME.EDIT_MODE
                  : SECTION.EDIT_SECTION_NAME.VIEW_MODE
              }
            >
              <span
                suppressContentEditableWarning={true}
                className={classes.editableDiv}
                contentEditable={editMode}
              >
                Skills
              </span>
            </Tooltip>

            {editMode && (
              <IconButton
                aria-label="delete"
                className={classes.iconDetailOverride}
                onClick={(evt) => handleClick(evt, SECTION.SKILLS_SECTION)}
              >
                <Tooltip title="Edit Skills" aria-label="Edit Skills">
                  <EditIcon className={classes.iconDetailOverride} />
                </Tooltip>
              </IconButton>
            )}
          </h2>
          <ExpertiseComponent
            data={props.initialData.skills}
            type={props.viewType.skills}
          />
          {/* {props.initialData.skills.map((x, index) => (
            <Button
              key={index}
              className={classes.button}
              variant="contained"
              size="small"
              color="primary"
            >
              {x}
            </Button>
          ))} */}
        </Paper>
      </motion.div>
      <motion.div
        drag={editMode}
        dragConstraints={constraintsRef}
        className={cx(s.projects, s.resumeSectionContainer)}
      >
        <Paper className={cx(classes.section)}>
          <h2
            className={cx(
              classes.primaryThemeColor,
              classes.sectionUnderline,
              s.sectionHeading,
              {
                [s.editMode]: editMode,
              }
            )}
          >
            <Tooltip
              title={
                editMode
                  ? SECTION.EDIT_SECTION_NAME.EDIT_MODE
                  : SECTION.EDIT_SECTION_NAME.VIEW_MODE
              }
            >
              <span
                suppressContentEditableWarning={true}
                className={classes.editableDiv}
                contentEditable={editMode}
              >
                Projects
              </span>
            </Tooltip>

            {editMode && (
              <IconButton
                aria-label="delete"
                className={classes.iconDetailOverride}
                onClick={(evt) => handleClick(evt, SECTION.PROJECTS)}
              >
                <Tooltip title="Edit Projects" aria-label="Edit Projects">
                  <EditIcon className={classes.iconDetailOverride} />
                </Tooltip>
              </IconButton>
            )}
          </h2>
          <ListComponent data={props.initialData.projects} />
        </Paper>
      </motion.div>
      <motion.div
        drag={editMode}
        dragConstraints={constraintsRef}
        className={cx(s.education, s.resumeSectionContainer)}
      >
        <Paper className={cx(classes.section)}>
          <h2
            className={cx(
              classes.primaryThemeColor,
              classes.sectionUnderline,
              s.sectionHeading,
              {
                [s.editMode]: editMode,
              }
            )}
          >
            <Tooltip
              title={
                editMode
                  ? SECTION.EDIT_SECTION_NAME.EDIT_MODE
                  : SECTION.EDIT_SECTION_NAME.VIEW_MODE
              }
            >
              <span
                suppressContentEditableWarning={true}
                className={classes.editableDiv}
                contentEditable={editMode}
              >
                Education
              </span>
            </Tooltip>

            {editMode && (
              <IconButton
                aria-label="delete"
                className={classes.iconDetailOverride}
                onClick={(evt) => handleClick(evt, SECTION.EDUCATION)}
              >
                <Tooltip title="Edit Education" aria-label="Edit Education">
                  <EditIcon className={classes.iconDetailOverride} />
                </Tooltip>
              </IconButton>
            )}
          </h2>
          <Education data={props.initialData.education} />
        </Paper>
      </motion.div>
      {Object.keys(props.additionalSections).map((key, index) => {
        return (
          props.additionalSections[key].isVisible && (
            <motion.div
              key={index}
              drag={editMode}
              className={cx(
                {
                  [s.language]: key === "language",
                  [s.awards]: key === "awards",
                  [s.certificates]: key === "certificates",
                },
                s.resumeSectionContainer
              )}
              dragConstraints={constraintsRef}
            >
              <Paper
                className={cx(
                  { [classes.section]: key !== "certificates" },
                  classes.leftSection
                )}
                // className={cx(s.language, s.resumeSectionContainer)}
              >
                <h2
                  className={cx(
                    classes.primaryThemeColor,
                    s.sectionHeading,
                    classes.sectionUnderline,
                    {
                      [s.editMode]: editMode,
                    }
                  )}
                >
                  <Tooltip
                    title={
                      editMode
                        ? SECTION.EDIT_SECTION_NAME.EDIT_MODE
                        : SECTION.EDIT_SECTION_NAME.VIEW_MODE
                    }
                  >
                    <span
                      suppressContentEditableWarning={true}
                      className={classes.editableDiv}
                      contentEditable={editMode}
                    >
                      {key}
                    </span>
                  </Tooltip>

                  {editMode && (
                    <IconButton
                      aria-label="delete"
                      className={classes.iconDetailOverride}
                      onClick={(evt) =>
                        handleClick(
                          evt,
                          key === "language"
                            ? SECTION.SKILLS_SECTION
                            : SECTION.PROJECTS,
                          key
                        )
                      }
                    >
                      <Tooltip title="Edit Skills" aria-label="Edit Skills">
                        <EditIcon className={classes.iconDetailOverride} />
                      </Tooltip>
                    </IconButton>
                  )}
                </h2>
                {key === "language" && (
                  <ExpertiseComponent
                    data={props.additionalSections.language.data}
                    type={props.viewType.language}
                  />
                )}
                {key !== "language" && (
                  <ListComponent data={props.additionalSections[key].data} />
                )}
              </Paper>
            </motion.div>
          )
        );
      })}
    </div>
  );
};

export default SideDetailsTemplate;

const compClasses = (theme) => ({
  button: {
    backgroundColor: theme.palette.primary.main,
    margin: "0 10px 10px 0",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      cursor: "default",
    },
  },
  iconDetailOverride: {
    height: "0.7em",
    width: "0.7em",
    padding: 0,
    borderRadius: "50%",
    color: theme.palette.primary.main,
  },
  sectionUnderline: {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
  leftSection: {
    backgroundColor: `rgba(${hexToRgbA(theme.palette.primary.main)}, 0.4)`,
    // "&:before": {
    //   position: "absolute",
    //   content: "''",
    //   top: "15px",
    //   background: theme.palette.primary.main,
    //   left: `-${theme.typography.pxToRem(20)}`,
    //   width: "1rem",
    //   height: "1.5rem",
    // },
  },
  editableDiv: {
    cursor: "text",
    "&:focus": {
      outline: `1px solid ${theme.palette.primary.main}`,
      // cursor: "default",
      padding: "0 10px",
    },
  },
  // gridLine: {
  //   border: `0.5px solid ${
  //     theme.palette.type === "dark"
  //       ? "rgba(255,255,255,0.04)"
  //       : "rgba(0,0,0,0.04)"
  //   }`,
  // },
});
